<template>
<v-container fluid :class="{'px-0':$vuetify.breakpoint.xsOnly}">

  <PanelBar></PanelBar>

  <template v-for="pie in pies">
    <PanelDetail
      :pie="pie" :key="pie" :data="getPieData(pie)" :online="getOnlineData(pie)"
      :temperatureUnit="userTemperatureUnit"
      @command="command" @toast="val=>$emit('toast', val)" />
  </template>

  <LinkDeviceButton :hint="linkButtonHint" :user="userAuth" />
  <ProgressBar :visible="userDeviceLoading" />
</v-container>
</template>

<script>
import User from '@/components/auth/User'
import PanelDetail from '@/components/panel/PanelDetail'
import PanelBar from '@/components/utils/PanelBar'
import ProgressBar from '@/components/utils/ProgressBar'
import LinkDeviceButton from '@/components/utils/LinkDeviceButton'

export default {
  name: 'Panel',
  mixins: [User],
  components: {
    PanelDetail,
    PanelBar,
    ProgressBar,
    LinkDeviceButton
  },
  computed: {
    pies() {
      return Object.keys(this.userDevice).filter(d => this.userDevice[d].info);
    },
    linkButtonHint() {
      return !this.userDeviceLoading && Object.keys(this.userDevice).length==0;
    }
  },
  methods: {
    command(val) {
      this.doCommand({
        ...val,
        agent: {
          id: this.userId
        }
      }, 'command');
    },
    getPieData(pie) {
      return this.userDevice[pie] || {};
    },
    getOnlineData(pie) {
      return this.userDeviceOnline[pie] || {};
    }
  }
}
</script>
